import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { TranslateModule } from '@ngx-translate/core';
import { MatListModule, MatNavList } from '@angular/material/list';
import { Location, NgStyle } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FerreroPlugin } from '@app-types/api/ferrero-webcodes';
import { AuthenticationService } from '@app-services/auth/authentication.service';
import { LocalStorageService } from '@app-services/local-storage.service';
import { STORAGE_NAMES, USER_ROLE } from '@app-shared/constants/constants';
import { MatSelectChange, MatSelectModule } from '@angular/material/select';
import { UserContract } from '@app-types/api/user';
import { UserWorkspaceService } from '@app-services/user-workspace-service';
import packageInfo from '../../../../package.json';
import { UserClient } from '@app-services/api/clients/user.client';

const { CLIENT_ID, SELECTED_ORGANISATION, PRE_RELEASE } = STORAGE_NAMES;

@Component({
  selector: 'app-nav-sidenav',
  imports: [
    MatSelectModule,
    MatSidenavModule,
    TranslateModule,
    MatNavList,
    MatListModule,
    RouterLink,
    NgStyle,
  ],
  templateUrl: './nav-sidenav.component.html',
  styleUrls: ['./nav-sidenav.component.scss'],
})
export class NavSidenavComponent implements OnInit {
  @Input() userRole = '';
  @Input() settingRoute = '';
  @Input() organizationName = '';
  @Output() emailsClick = new EventEmitter();
  @Output() rightMenuOpen = new EventEmitter();

  user: UserContract;
  version = packageInfo.version;
  clientId: string;
  userRoles = USER_ROLE;
  preRelease?: boolean;

  constructor(
    private location: Location,
    private authenticationService: AuthenticationService,
    private localStorageService: LocalStorageService,
    public userWorkspaceService: UserWorkspaceService,
    private userClient: UserClient
  ) {}

  ngOnInit(): void {
    this.user = this.userWorkspaceService.user;
    this.clientId = this.localStorageService.getData(CLIENT_ID);
    this.preRelease = this.localStorageService.getData(PRE_RELEASE);
  }

  async onChangeOrganization($event: MatSelectChange): Promise<void> {
    this.localStorageService.setData(SELECTED_ORGANISATION, {
      organizationId: $event.value,
    });
    this.userClient.setLastOrganization({ organizationId: $event.value });
    window.location.href = '/';
  }

  public isCurrentSelect(path: string): boolean {
    const locationPath = this.location.path();
    const isCurrent = locationPath.toString().split('/');
    return isCurrent[1] === path;
  }

  onEmailsClick(): void {
    this.emailsClick.emit();
  }

  sidenavOpen(): void {
    this.rightMenuOpen.emit();
  }

  public pluginsPermission(): boolean {
    const ferreroPlugin = new FerreroPlugin();
    return (
      !!this.userWorkspaceService.currentOrganization?.organizationId &&
      ferreroPlugin.codes.includes(
        this.userWorkspaceService.currentOrganization.organizationId
      )
    );
  }

  async logout(): Promise<void> {
    await this.authenticationService.logout();
  }

  redirectDoc(): void {
    window.location.href = 'http://85.235.146.186:5300';
  }
}
